console.log("start");
// (window.WebViewJavascriptBridge as any) = true;
console.log(window.WebViewJavascriptBridge);
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store, { key } from "./store";
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "element-plus/dist/index.css";
import "@/assets/css/global.scss";
// import useCreateSandBox from "./hooks/useCreateSandBox";
import "./utils/rem";
import { ensureSheetReportRuntime } from "@/utils/sheetReportRuntime";

// const { createAndroidMusicScoreSandbox } = useCreateSandBox();
// createApp(App).use(store).use(router).mount("#app");
const initSheetLibResult = (window as any).initSheetLib();

const render = async () => {
  try {
    await initSheetLibResult;
  } catch (e) {
    console.error("initSheetLib error", e);
  }
  // window.Display 就绪后启动 telemetry 运行时（幂等；未登录无 token 时 no-op，
  // 曲谱组件 onMounted 会再次确保）。fire-and-forget，不阻塞首屏挂载。
  ensureSheetReportRuntime();
  const app = createApp(App);
  app.use(ElementPlus, {
    locale: zhCn,
  });
  app.use(store, key);
  app.use(router);
  // createAndroidMusicScoreSandbox(app);
  app.mount("#app");
};

render();
